import Vue from 'vue'

const state = {
  isApplying: false,
  hasAppliedExtras: false,
  appliedExtras: null
}

const actions = {
  APPLY_EXTRAS: ({commit}, submitData) => {
    commit('REQUEST_APPLY_EXTRAS')
    const url = 'bookings/apply-extras'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('FINISH_APPLY_EXTRAS')
        if (!response.error) {
          const appliedExtras = {
            extra_id: (submitData.extra_id) ? submitData.extra_id : null,
            total_price: response.total_price,
            total_professional_income: response.total_professional_income
          }
          commit('SET_APPLIED_EXTRAS', appliedExtras)
        }
      })
  }
}

const mutations = {
  REQUEST_APPLY_EXTRAS: (state) => {
    state.isApplying = true
  },
  FINISH_APPLY_EXTRAS: (state) => {
    state.isApplying = false
  },
  SET_APPLIED_EXTRAS: (state, appliedExtras) => {
    state.appliedExtras = appliedExtras
  },
  SET_HAS_APPLIED_EXTRAS: (state, status) => {
    state.hasAppliedExtras = status
  }
}

const getters = {
  getState: state => {
    return state
  },
  getAppliedExtras: state => {
    return state.appliedExtras
  },
  getHasAppliedExtras: state => {
    return state.hasAppliedExtras
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/extras.js